// extracted by mini-css-extract-plugin
export default {"container":"navigation_container__nSy11","content":"navigation_content__n57wU"};